import { Badge, Text } from '@mantine/core';

/**
 * MUTAXASSISLIK — ism yonida ko'rsatiladigan qisqa yorliq.
 *
 * Nega alohida komponent: bu yorliq o'nlab joyda chiqadi (xodimlar ro'yxati,
 * kartochka, dars jadvali, davomat, sinf rahbari). Har birida qo'lda yozilsa,
 * bir joyda nuqta-vergul, boshqasida qavs bo'lib ketardi va keyinchalik
 * ko'rinishini o'zgartirish uchun hammasini qidirib chiqish kerak bo'lardi.
 *
 * Ikki ko'rinish:
 *   matn (asosiy) — jadval qatorlari uchun. Nishoncha zich jadvalda qatorni
 *     baland qilib yuboradi va ko'zni charchatadi, shuning uchun oddiy xira matn.
 *   nishoncha    — kartochka sarlavhasida, ism katta bo'lgan joyda.
 *
 * Qiymat bo'sh bo'lsa HECH NARSA chizilmaydi — bo'sh qavs yoki chiziqcha
 * ro'yxatni ifloslantirardi.
 */
export function Specialty({ value, badge }: { value?: string | null; badge?: boolean }) {
  const v = value?.trim();
  if (!v) return null;

  if (badge) {
    return <Badge variant="light" color="gray" size="sm" tt="none">{v}</Badge>;
  }
  return (
    <Text span size="xs" c="dimmed" ml={6} style={{ whiteSpace: 'nowrap' }}>
      {v}
    </Text>
  );
}
